import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { optionDirection } from 'src/app/enums/comman.enums';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnChanges {
  @Input() field: Field;
  @Input() form: FormGroup;
  optionDirection = optionDirection;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['field'] && this.form && this.field?.name) {
      const control = this.form.get(this.field.name);
      if (control) {
        if (this.field.disabled) {
          control.disable();
        } else {
          control.enable();
        }
      }
    }
  }
}
